import {
  PolicyPayer,
  PolicyStatus,
  PolicyType,
  PricingRule,
  schemes,
  zSchema,
} from "@zeal/common";

export const getChargesPoliciesRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  status: zSchema.nativeEnum(PolicyStatus).optional(),
  policyID: schemes.uuid().optional(),
  includeFeePolicy: zSchema.boolean().optional(),
});

export type TGetChargesPoliciesRequestSchema = zSchema.infer<
  typeof getChargesPoliciesRequestSchema
>;

export const getChargesPoliciesResponseSchema = zSchema.array(
  zSchema.object({
    companyID: schemes.companyID(),
    effectiveDate: schemes.isoDate(),
    policyID: schemes.uuid(),
    status: zSchema.nativeEnum(PolicyStatus),
    policyType: zSchema.nativeEnum(PolicyType),
    paidBy: zSchema.nativeEnum(PolicyPayer),
    pricing: zSchema.array(
      zSchema.object({
        amount: zSchema.number(),
        percentage: zSchema.number(),
        rule: zSchema.nativeEnum(PricingRule),
        maxCap: zSchema.number().optional(),
      })
    ),
  })
);

export type TGetChargesPoliciesResponseSchema = zSchema.infer<
  typeof getChargesPoliciesResponseSchema
>;
